import CrudTable from "@/components/admin/CrudTable";

export default function AdminSolutions() {
  return (
    <CrudTable
      title="Solutions"
      testid="admin-solutions"
      endpoint="/solutions"
      adminEndpoint="/admin/solutions"
      columns={[
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
        { key: "featured", label: "Featured", render: (r) => (r.featured ? "★" : "—") },
      ]}
      defaults={{ slug: "", title: "", category: "", tagline: "", description: "", image: "", featured: false, applications: [], benefits: [], specifications: [] }}
      fields={[
        { name: "slug", label: "Slug (URL)", help: "e.g. floating-marinas" },
        { name: "title", label: "Title" },
        { name: "category", label: "Category" },
        { name: "tagline", label: "Tagline (short)" },
        { name: "description", label: "Description", type: "textarea" },
        { name: "image", label: "Card Image URL" },
        { name: "hero_image", label: "Hero Image URL (optional)" },
        { name: "applications", label: "Applications (one per line)", type: "array" },
        { name: "benefits", label: "Benefits (one per line)", type: "array" },
        { name: "specifications", label: "Specifications (one per line)", type: "array" },
        { name: "featured", label: "Featured on home", type: "checkbox" },
      ]}
    />
  );
}
